import { anyRarity } from './content.js';
export const KASSIM = { mob: 'caravan-master', biome: 'desert' };
export const ZAHRA = { mob: 'dune-tracker', biome: 'desert' };
export const NEFER = { mob: 'desert-scribe', biome: 'desert' };
export const MERET = { mob: 'jackal-priestess', biome: 'desert' };
export const SMITH = { mob: 'smith', biome: 'desert' };
export const MERCHANT = { mob: 'merchant', biome: 'desert' };
export const ALCHEMIST = { mob: 'alchemist', biome: 'desert' };
/**
 * The desert's chain, first half: Sablerouge and its caravan lost by the
 * Hyenas' Cave, until the tracks lead west to the Forgotten Obelisk.
 */
export const DESERT_CHAIN_START = [
    {
        id: 'desert-arrival',
        name: 'Le souffle de Sablerouge',
        biome: 'desert',
        level: 12,
        giver: KASSIM,
        turnIn: KASSIM,
        offer: 'Bienvenue à Sablerouge ! Je suis Kassim, maître des caravanes. Ici, le soleil est plus dangereux que les monstres. Touche l’arche de la place, puis va dire bonjour au forgeron et à l’alchimiste. Et bois de l’eau, tu as une tête de raisin sec.',
        summary: 'Enregistrer le portail de Sablerouge, saluer le forgeron et l’alchimiste, puis revenir à Kassim.',
        pending: 'L’arche est au milieu de la place, la forge et l’alchimiste juste à côté. Marche à l’ombre des murs !',
        complete: 'De l’eau, une arme et une arche pour revenir : tu en sais déjà plus que la moitié de mes chameliers. Et eux, je les paie !',
        objectives: [
            { kind: 'portal', label: 'Enregistrer le portail de Sablerouge', portal: 'desert' },
            {
                kind: 'talk',
                label: 'Saluer le forgeron',
                npc: SMITH,
                line: 'Tu vois ces rayures sur ton épée ? C’est le sable. Ici, il abîme tout ! Rapporte-moi du sable de verre, je renforcerai ton équipement. Et prépare ta bourse, le charbon coûte cher dans le désert.',
            },
            {
                kind: 'talk',
                label: 'Saluer l’alchimiste',
                npc: ALCHEMIST,
                line: 'Des bandages de momie, oui, je sais, c’est dégoûtant. Mais ils ont trempé mille ans dans des huiles spéciales, et ça soigne à merveille ! Rapporte-moi ça et des crocs de hyène, je t’en ferai des potions.',
            },
        ],
        reward: { xp: 400, gold: 80 },
    },
    {
        id: 'desert-market',
        name: 'Vêtu pour le soleil',
        biome: 'desert',
        level: 12,
        requires: ['desert-arrival'],
        giver: MERCHANT,
        turnIn: MERCHANT,
        offer: 'Un casque en fer, ici ? Tu vas cuire comme un œuf ! Il te faut un Némès, la coiffe des anciens rois, et des sandales. Achète-les et mets-les, je te rembourse une partie. Tu seras ma publicité ambulante !',
        summary: 'Acheter et porter le Némès et les Sandales du pharaon chez le marchand de Sablerouge.',
        pending: 'Achète le Némès et les Sandales, et mets-les. Il faut que les gens te voient avec !',
        complete: 'Regarde-toi ! On dirait un pharaon. Un petit pharaon. Reviens pour le reste de la tenue, je fais crédit aux gens bien habillés.',
        objectives: [
            { kind: 'wear', label: 'Porter un Némès du pharaon', items: anyRarity('pharaoh-helm') },
            { kind: 'wear', label: 'Porter des Sandales du pharaon', items: anyRarity('pharaoh-boots') },
        ],
        reward: { xp: 300, gold: 60 },
    },
    {
        id: 'desert-forge',
        name: 'Le feu de la forge',
        biome: 'desert',
        level: 12,
        requires: ['desert-arrival'],
        giver: SMITH,
        turnIn: SMITH,
        offer: 'Ton équipement est à trois crans ? Dans le désert, en dessous de quatre, ça casse au premier coup de dent de hyène ! J’ai vu des gens revenir avec une moitié d’épée. Fais monter une pièce à quatre crans et viens me la montrer.',
        summary: 'Faire porter une pièce d’équipement à +4 par le forgeron.',
        pending: 'Il me faut une pièce à quatre crans. Le sable de verre, toutes les bêtes du désert en ont, elles en avalent en marchant.',
        complete: 'Voilà qui tiendra le coup ! Garde ce sable, j’en ai plein les bottes. Vraiment, plein les bottes.',
        objectives: [{ kind: 'upgrade', label: 'Une pièce portée à +4', level: 4 }],
        reward: { xp: 500, gold: 100, items: [{ templateId: 'glass-sand', quantity: 3 }] },
    },
    {
        id: 'desert-hyenas',
        name: 'Les rôdeuses des dunes',
        biome: 'desert',
        level: 12,
        requires: ['desert-arrival'],
        giver: KASSIM,
        turnIn: KASSIM,
        offer: 'Les hyènes ricanent sous les remparts toute la nuit, et mes chameliers refusent de sortir. Ils sont payés pour sortir ! Chasse les hyènes et rapporte-moi leurs crocs. Je les poserai sur la table devant ces froussards.',
        summary: 'Chasser les hyènes autour de Sablerouge et rapporter leurs crocs à Kassim.',
        pending: 'Les hyènes chassent en groupe. Attire-les une par une, sinon elles vont t’encercler.',
        complete: 'Mes chameliers ressortent, ils ont même chanté ! Faux, mais ils ont chanté. L’alchimiste a laissé ces potions pour toi. Il dit qu’il y a des crocs dedans, je n’ai pas voulu en savoir plus.',
        objectives: [
            { kind: 'kill', label: 'Hyènes chassées', mobs: ['hyena'], count: 15 },
            { kind: 'collect', label: 'Crocs de hyène', item: 'hyena-fang', count: 5 },
        ],
        reward: { xp: 700, gold: 140, items: [{ templateId: 'desert-tonic', quantity: 3 }] },
    },
    {
        id: 'desert-scorpions',
        name: 'Dards dans le sable',
        biome: 'desert',
        level: 13,
        requires: ['desert-hyenas'],
        giver: KASSIM,
        turnIn: ALCHEMIST,
        offer: 'Deux de mes porteurs ont marché sur des scorpions géants hier, et ils ont une grosse fièvre. L’alchimiste peut les soigner, mais il lui faut des dards de scorpion bien frais. Va en chercher, et vite !',
        summary: 'Abattre des scorpions géants et porter leurs dards à l’alchimiste de Sablerouge.',
        pending: 'Il me faut des dards de scorpion, bien frais ! Ceux d’hier ne valent plus rien, le soleil sèche le venin.',
        complete: 'Parfait, ils sont encore frais ! Les porteurs seront debout demain. Et ils vont se plaindre du goût du remède, comme d’habitude. Prends ces potions, j’en ai fait trop.',
        objectives: [
            { kind: 'kill', label: 'Scorpions géants abattus', mobs: ['scorpion'], count: 15 },
            { kind: 'collect', label: 'Dards de scorpion', item: 'scorpion-stinger', count: 5 },
        ],
        reward: { xp: 800, gold: 160, items: [{ templateId: 'desert-potion', quantity: 2 }] },
    },
    {
        id: 'desert-wreck',
        name: 'La caravane disparue',
        biome: 'desert',
        level: 13,
        requires: ['desert-scorpions'],
        giver: KASSIM,
        turnIn: ZAHRA,
        offer: 'Il y a dix jours, ma plus belle caravane devait revenir de l’est. Douze chameaux, six porteurs et des épices qui valent une fortune. Et rien, disparue ! Zahra, la pisteuse, campe près de la Grotte des Hyènes. Si quelqu’un a vu ses traces, c’est elle.',
        summary: 'Rejoindre la Grotte des Hyènes, à l’est de Sablerouge, et parler à la traqueuse Zahra.',
        pending: 'La Grotte des Hyènes est à l’est, au pied des rochers. Zahra ne s’en éloigne jamais, elle dit que les hyènes lui tiennent compagnie.',
        complete: 'La caravane de Kassim ? Je l’ai retrouvée ! Les chariots sont renversés dans les dunes. Mais pas un chameau, pas un porteur. Juste des hyènes partout.',
        objectives: [
            { kind: 'reach', label: 'Atteindre la Grotte des Hyènes', landmark: 'Grotte des Hyènes' },
        ],
        reward: { xp: 400, gold: 80 },
    },
    {
        id: 'desert-den',
        name: 'La grotte aux ricanements',
        biome: 'desert',
        level: 13,
        requires: ['desert-wreck'],
        giver: ZAHRA,
        turnIn: ZAHRA,
        offer: 'Je ne peux pas fouiller les chariots avec des hyènes dans le dos. Elles sortent de la grotte par dizaines dès que le soleil baisse. Aide-moi à les chasser, et on verra ce qu’il reste dans les chariots.',
        summary: 'Abattre les hyènes autour de la Grotte des Hyènes pour que Zahra fouille les chariots.',
        pending: 'Tu entends encore des ricanements ? Alors il en reste !',
        complete: 'Merci ! J’ai pu fouiller tranquillement. Tiens, j’ai trouvé ces brassards dans un chariot. Personne ne viendra les réclamer.',
        objectives: [{ kind: 'kill', label: 'Hyènes abattues', mobs: ['hyena'], count: 20 }],
        reward: { xp: 900, gold: 180, items: [{ templateId: 'pharaoh-gloves-rare', quantity: 1 }] },
    },
    {
        id: 'desert-mangy',
        name: 'La Hyène galeuse',
        biome: 'desert',
        level: 13,
        requires: ['desert-den'],
        giver: ZAHRA,
        turnIn: ZAHRA,
        offer: 'Les hyènes ont une reine : une énorme hyène galeuse, grosse comme un chameau ! Elle ne sort que pour manger. Pose cette carcasse qui pue près d’une tanière, loin de la ville, et elle viendra. Attention, elle n’arrive jamais seule.',
        summary: 'Utiliser la carcasse faisandée près d’une tanière de hyènes, puis abattre la Hyène galeuse qui en sort.',
        pending: 'Pose la carcasse près d’une tanière de hyènes, loin du village. Si elle s’enfuit, recommence, elle a toujours faim.',
        complete: 'La reine est tombée ! Sans elle, la meute va se disperser. Il y a d’autres grosses bêtes comme elle dans le désert, avec leur nom en couleur. Si tu en croises une, prépare-toi, elles cachent souvent de beaux trésors !',
        grants: [{ templateId: 'hyena-bait', quantity: 1 }],
        objectives: [{ kind: 'kill', label: 'Hyène galeuse abattue', mobs: ['mangy-hyena'], count: 1 }],
        reward: { xp: 900, gold: 180, items: [{ templateId: 'desert-potion', quantity: 2 }] },
    },
    {
        id: 'desert-wraps',
        name: 'Des bandelettes dans le sable',
        biome: 'desert',
        level: 14,
        requires: ['desert-den'],
        giver: ZAHRA,
        turnIn: ZAHRA,
        offer: 'Regarde ces traces : ce ne sont pas les hyènes qui ont pris la marchandise. Ce sont des pas lents, qui traînent la jambe. Et il y a des bandages accrochés aux roues… Des momies ! Bats celles qui errent dans les dunes et rapporte-moi leurs bandages.',
        summary: 'Abattre des momies dans le désert et rapporter leurs bandelettes à Zahra.',
        pending: 'Les momies sont lentes, mais elles ne s’arrêtent jamais. Frappe, recule, et recommence.',
        complete: 'Il y a des dessins bizarres sur ces bandages. Moi, je sais lire les traces dans le sable, pas ça. Mais Kassim connaît quelqu’un.',
        objectives: [
            { kind: 'kill', label: 'Momies abattues', mobs: ['mummy'], count: 12 },
            { kind: 'collect', label: 'Bandelettes de momie', item: 'mummy-wrap', count: 5 },
        ],
        reward: { xp: 1000, gold: 200 },
    },
    {
        id: 'desert-report',
        name: 'Le rapport de la traqueuse',
        biome: 'desert',
        level: 14,
        requires: ['desert-mangy', 'desert-wraps'],
        giver: ZAHRA,
        turnIn: KASSIM,
        offer: 'Kassim croit que les hyènes ont mangé sa fortune. Va lui dire que ce sont des momies qui l’ont volée ! Et sur la route, chasse les scorpions qui attaquent les porteurs.',
        summary: 'Abattre les scorpions sur la route de Sablerouge et porter la nouvelle de Zahra à Kassim.',
        pending: 'Alors ? Tu as des nouvelles de ma caravane ? Raconte !',
        complete: 'Des momies ?! Les momies ne volent pas du poivre, quand même ! Elles cherchaient autre chose dans mes chariots… Et je crois savoir quoi. Oh là là.',
        objectives: [
            { kind: 'kill', label: 'Scorpions géants abattus', mobs: ['scorpion'], count: 10 },
        ],
        reward: { xp: 700, gold: 140 },
    },
    {
        id: 'desert-obelisk',
        name: 'L’Obélisque Oublié',
        biome: 'desert',
        level: 14,
        requires: ['desert-report'],
        giver: KASSIM,
        turnIn: NEFER,
        offer: 'Loin à l’ouest, au pied de l’Obélisque Oublié, vit une savante qui s’appelle Néfer. Elle lit les vieux dessins comme moi je lis un contrat. Et elle est aussi chère que moi ! Montre-lui les bandages. Elle nous dira qui commande ces momies.',
        summary: 'Traverser le désert jusqu’à l’Obélisque Oublié, à l’ouest, et parler à la scribe Néfer.',
        pending: 'L’Obélisque est loin à l’ouest, après les dunes. Emporte deux gourdes d’eau !',
        complete: 'Pose-les là. Et ne touche à rien d’autre ! Ce symbole… c’est celui d’un roi dont on a effacé le nom de toutes les pierres du désert. Je cherche ce nom depuis dix ans ! Et ses momies se sont réveillées. Ce n’est pas bon signe.',
        objectives: [
            { kind: 'reach', label: 'Atteindre l’Obélisque Oublié', landmark: 'Obélisque Oublié' },
        ],
        reward: { xp: 500, gold: 100 },
    },
];
//# sourceMappingURL=desert-chain-1.js.map